import ReportsTransaction from './ReportsTransaction'

export default ReportsTransaction
